import React, { useState } from 'react'
import NewActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import styles from './RowAge.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const RowAge = ({ age, index, action }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: 'Edit', action: 'edit' },
    { name: 'Delete', action: 'delete' },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {age.name}
          </div>
          <div className={styles.buttons}>
            <NewActionMenu variant='simple' onSimpleAction={toggleExpand} />
            <ActionMenu menu={menu} action={action} items={age} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Age:</div>
            <div className={styles.info}>{age.name}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default RowAge
